
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { EnhancedBookData } from '../CreateReportForm/EnhancedBookSelectionCard';
import { FormData } from './formSchema';

interface GroupedReport {
  authorId: string;
  year: number;
  quarter: number;
  reports: any[];
  totalSales: number;
  totalAmount: number;
  status: string;
  countries: Set<string>;
}

export const useFormInitialization = (form: UseFormReturn<FormData>, reportGroup: GroupedReport) => {
  useEffect(() => {
    if (reportGroup && reportGroup.reports.length > 0) {
      const enhancedBooks: EnhancedBookData[] = reportGroup.reports.map((report, index) => ({
        bookId: report.bookId || report.book_id,
        unitsSold: report.unitsSold || report.salesCount || 0,
        grossSales: report.grossSales || report.amount || 0,
        netSales: report.netSales !== undefined ? report.netSales : 0, // Use actual netSales value, don't default to amount
        royaltyAmount: report.royaltyAmount || report.amount || 0,
        bookFormat: report.bookFormat || 'paperback',
        country: report.country || 'US',
        formatId: `${report.bookId || report.book_id}-${index}`,
        reportId: report.id
      }));

      form.setValue('books', enhancedBooks);
    }
  }, [reportGroup, form]);
};
